import { Component, Input } from '@angular/core';
import { copyFadeIn } from '@shared/animations/fade.animation';

@Component({
  selector: 'ts-copy',
  templateUrl: './copy.component.html',
  animations: [copyFadeIn],
  imports: []
})
export class CopyComponent {
  @Input() text: string;
  copied: boolean;

  copyText(): void {
    navigator['clipboard'].writeText(this.text).then(() => {
      this.copied = true;

      setTimeout(() => {
        this.copied = false;
      }, 1000);
    });
  }
}
